const range = (n: number) => Array.from(Array(n).keys())

export default range
